import React, { useEffect, useState } from "react"
import moment from "moment"
import { submissionsApi } from "../../../../../utils"
import { AssessmentTypeEnum } from "../../../models/AssessmentTypeEnum"
import { throwApiError } from "../../../store/error-handling-actions"
import { ReflectionActionsEnum } from "../../Shared/ReflectionActionsEnum"
import { ReflectionComponentsEnum } from "../../Shared/ReflectionComponentsEnum"
import DynamicMessage from "../../../UI/Popups/DynamicMessage/DynamicMessage"
import { DynamicMessageTypeEnum } from "../../../models/DynamicMessageTypeEnum"
import { useSelector } from "react-redux"


const ReflectionView = ({ question, isStudent, hundleUpdateAnswer, studyGroupId }) => {

    const [typeComponent, setComponent] = useState(null)
    const [answerValue, setAnswerValue] = useState()
    const [message, setMessage] = useState(null)
    const { texts } = useSelector(state => state.translate);

    const fetchUpdate = () => {
        if (answerValue) {
            const newQuestion = { ...question, answer: answerValue }
            var data = {
                assessmentId: question.id,
                solution: answerValue,
                studyGroupId
            }
            submissionsApi.submissionsSubmitPost({ submissionSubmitInput: data }, (error, resdata, response) => {
                if (error) {
                    if (error?.response?.body?.code == 413) {
                        setMessage(<DynamicMessage
                            type={DynamicMessageTypeEnum.Warn}
                            title={texts.LessonInEditByTeamMemberSaveCopy}
                            showCancel={false}
                            confirmText={texts.ok}
                            confirmFunc={() => setMessage(null)} />);
                    }
                    else
                        throwApiError({ userMessage: "", error: error, statusCode: response?.statusCode, message: "submissionsSubmitPost " + error.message, level: 1, component: "ReflectionView" })
                }
                else {
                    hundleUpdateAnswer(newQuestion)

                }
            })
        }
    }

    useEffect(() => {
        question?.answer ? setAnswerValue(question.answer) : setAnswerValue(null)
    }, [question])

    useEffect(() => {
        if (question?.type) {
            const QuestionTypeComponent = ReflectionComponentsEnum[Object.keys(AssessmentTypeEnum).find(key => AssessmentTypeEnum[key] === (question.type))]
            setComponent(
                <QuestionTypeComponent
                    action={ReflectionActionsEnum.View}
                    question={question}
                    isStudent={isStudent}
                    setAnswerValue={setAnswerValue}
                    answerValue={answerValue}
                />)
        }
    }, [question, answerValue])

    useEffect(() => {
        fetchUpdate()
    }, [answerValue])

    return (
        <>
            {typeComponent}
            {message}
        </>
    )
}

export default ReflectionView
